export default "__VITE_ASSET__C228JbGZ__"